import { getLocales, Language } from 'assets/locales/Locale';
import { compact } from 'lodash';

type CategorizedLossCode = {
  category?: string;
  lossCodeCategories?: { nameEn?: string; nameFr?: string }[];
};

export function getLossCodeCategoryNames(lossCode: CategorizedLossCode): string[] {
  const { currentLanguage } = getLocales();

  const names = compact(
    lossCode?.lossCodeCategories?.map((it) => (currentLanguage === Language.french ? it?.nameFr : it?.nameEn))
  );

  return names.length ? names : compact([lossCode?.category]);
}
